import { useMemo, useState } from 'react';

import { useTranslation } from '@mint-lib/i18n';
import { Time } from '@mint-lib/icons';
import {
  Chip,
  Drawer,
  DrawerContent,
  DrawerHeader,
  DrawerOverlay,
  DrawerPortal,
  DrawerRoot,
  DrawerTitle,
  DrawerTrigger,
} from '@mint-lib/tw-components';

import { useFlightVersionListApi } from '../../../../../../api/queries/useFlightVersionListApi.js';
import { useChosenVersionId } from '../../../../../../hooks/useChosenVersionId.js';
import { VersioningDrawerContent } from './VersioningDrawerContent.jsx';

export const VersioningDrawer = () => {
  const { t } = useTranslation('@myn/planning_v2');
  const [isDrawerOpen, setIsDrawerOpen] = useState(false);

  const chosenVersionId = useChosenVersionId();

  const { data: flightVersions = [], isFetching: isVersionListFetching } =
    useFlightVersionListApi();

  const versionLabel = useMemo(() => {
    if (!flightVersions?.length) return t('Current');

    const version = chosenVersionId
      ? flightVersions.find((v) => v.id === chosenVersionId)
      : flightVersions.find((v) => v.isCurrent);

    return version?.name ?? t('Current');
  }, [flightVersions, chosenVersionId, t]);

  return (
    <Drawer open={isDrawerOpen} onOpenChange={setIsDrawerOpen}>
      <DrawerTrigger asChild>
        <Chip
          variant="outline"
          color="tertiary"
          data-dd-action-name="Versioning drawer: open"
        >
          <Time />
          <span>{versionLabel}</span>
        </Chip>
      </DrawerTrigger>
      <DrawerPortal>
        <DrawerOverlay />
        <DrawerRoot size="25%" className="p-6">
          <DrawerHeader>
            <DrawerTitle>{t('Version history')}</DrawerTitle>
          </DrawerHeader>
          <DrawerContent>
            {isDrawerOpen && (
              <VersioningDrawerContent
                onOpenChange={setIsDrawerOpen}
                flightVersions={flightVersions}
                isVersionListFetching={isVersionListFetching}
              />
            )}
          </DrawerContent>
        </DrawerRoot>
      </DrawerPortal>
    </Drawer>
  );
};
